export default __webpack_public_path__ + "static/media/CustomTokens.d5ec3482.mp4";